exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#drop-area[data-v-3807a339]{border:2px dashed #ccc;border-radius:20px;width:100%;font-family:sans-serif;padding:20px}.drag-active[data-v-3807a339]{border-color:var(--v-primary-base);background:var(--v-secondary-base)}p[data-v-3807a339]{margin-top:0}.my-form[data-v-3807a339]{margin-bottom:10px}#gallery[data-v-3807a339]{margin-top:10px}#gallery img[data-v-3807a339]{width:150px;margin-bottom:10px;margin-right:10px;vertical-align:middle}#fileElem[data-v-3807a339]{display:none}", ""]);

// exports
